import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn } from 'intact-vue';
import { getRestProps } from '../utils';
import { makeFormStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    layout = _this$get.layout,
    size = _this$get.size;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-form"] = true, _classNameObj[className] = className, _classNameObj[k + "-" + layout] = layout, _classNameObj[k + "-" + size] = size !== 'default', _classNameObj[makeFormStyles(k)] = true, _classNameObj);
  return _$cv('form', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-submit': this.onSubmit,
    'noValidate': true
  }), children);
}
;